/**
 * Corner Builder V2 - Simplified builder with pill-style sizes
 *
 * Changes from V1:
 * - Size displayed as pills instead of S/M/L dropdowns
 * - No Material option (removed)
 * - No Remote option (removed)
 * - Auto-selection of first available combination on page load
 * - Auto-cascade selection when changing options
 * - "Without top" mode for frame-only orders
 */

document.addEventListener("DOMContentLoaded", () => {
  // Check if data is available
  if (typeof window.cornerBuilderData === 'undefined') {
    console.error('Corner Builder V2: Configuration data not found');
    return;
  }

  const data = window.cornerBuilderData;

  // DOM Elements
  const sizePillsContainer = document.getElementById('size-pills-container');
  const colorOptionsContainer = document.getElementById('color-options-container');
  // selectedSize span removed from UI
  const selectedColorSpan = document.getElementById('selectedColor');
  const selectedFrameSpan = document.getElementById('selectedFrame');
  const withoutTopCheckbox = document.getElementById('without-top-checkbox');
  const builderSection = document.querySelector('.corner-builder-v2');

  // State
  let currentSizeIndex = 0;
  let currentColorIndex = 0;
  let withoutTopMode = false;

  // ============================================
  // Size Pills Rendering
  // ============================================
  function renderSizePills() {
    if (!sizePillsContainer) return;

    sizePillsContainer.innerHTML = '';

    // Add "Frame only" pill first
    // const frameOnlyHtml = `
    //   <input
    //     type="radio"
    //     name="size-pill"
    //     id="size-pill-frame-only"
    //     class="size-pill"
    //     value="frame-only"
    //     data-index="-1"
    //     data-title="Frame only"
    //     data-frame-only="true"
    //   >
    //   <label for="size-pill-frame-only" class="size-pill-label">
    //     Frame only
    //   </label>
    // `;
    // sizePillsContainer.insertAdjacentHTML('beforeend', frameOnlyHtml);

    // Add size pills
    data.forEach((sizeOption, index) => {
      const pillHtml = `
        <input
          type="radio"
          name="size-pill"
          id="size-pill-${sizeOption.id}"
          class="size-pill"
          value="${sizeOption.id}"
          data-index="${index}"
          data-title="${sizeOption.title}"
          ${index === 0 ? 'checked' : ''}
        >
        <label for="size-pill-${sizeOption.id}" class="size-pill-label">
          ${sizeOption.title}
          ${sizeOption.sale ? `<span class="sale-badge">${sizeOption.sale}</span>` : ''}
        </label>
      `;
      sizePillsContainer.insertAdjacentHTML('beforeend', pillHtml);
    });

    // Add event listeners to size pills
    const sizePills = document.querySelectorAll('input[name="size-pill"]');
    sizePills.forEach(pill => {
      pill.addEventListener('change', onSizeChange);
    });

    // Initial size is auto-selected (first size pill after frame-only is checked)
  }

  // ============================================
  // Color Options Rendering
  // ============================================
  function renderColorOptions(sizeIndex) {
    if (!colorOptionsContainer) return;

    const sizeData = data[sizeIndex];
    if (!sizeData || !sizeData.colors) {
      colorOptionsContainer.innerHTML = '';
      return;
    }

    colorOptionsContainer.innerHTML = '';

    sizeData.colors.forEach((colorOption, index) => {
      const colorHtml = `
        <input
          type="radio"
          class="custom-radio"
          name="color"
          id="color-${colorOption.id}"
          value="${colorOption.id}"
          data-title="${colorOption.title}"
          data-topsqty="${colorOption.topsQty}"
          data-top_1_sku="${colorOption.top_1_sku}"
          data-top_1_id="${colorOption.top_1_id}"
          data-top_1_grommetqty="${colorOption.top_1_grommetQty}"
          data-top_1_grommetsize="${colorOption.top_1_grommetSize}"
          data-top_2_sku="${colorOption.top_2_sku || ''}"
          data-top_2_id="${colorOption.top_2_id || ''}"
          data-top_2_grommetqty="${colorOption.top_2_grommetQty || 0}"
          data-top_2_grommetsize="${colorOption.top_2_grommetSize || ''}"
          data-index="${index}"
          ${index === 0 ? 'checked' : ''}
        >
        <label
          for="color-${colorOption.id}"
          class="color_label color_${colorOption.id}">
          <span class="visually-hidden swatch-a11y-name">${colorOption.title}</span>
        </label>
      `;
      colorOptionsContainer.insertAdjacentHTML('beforeend', colorHtml);
    });

    // Add event listeners to color options
    const colorInputs = document.querySelectorAll('input[name="color"]');
    colorInputs.forEach(input => {
      input.addEventListener('change', onColorChange);
    });

    // Check stock availability
    checkColorStock();

    // Auto-select first available color
    autoSelectFirstAvailableColor();
  }

  // ============================================
  // Stock Checking
  // ============================================
  function getTopVariants() {
    const topJsonEl = document.querySelector('#hidden-variant-metafields-container');
    if (!topJsonEl) return null;
    try {
      return JSON.parse(topJsonEl.innerHTML);
    } catch (e) {
      console.error('Error checking stock:', e);
      return null;
    }
  }

  // A top counts as available only when its variant exists in the metafield AND has enough stock.
  // An empty id means the size has no such top (e.g. single-top sizes) -> nothing to block.
  // `needed` matters when left and right tops share one variant (e.g. 78x48 = 2 x 48x30).
  function isTopAvailable(topId, topVariants, needed = 1) {
    if (!topId) return true;
    const variant = topVariants.find(elem => +elem.variant_id === +topId);
    if (!variant || variant.variant_available === 'false') return false;
    // Untracked inventory or "continue selling when out of stock" -> quantity doesn't limit
    if (variant.variant_inventory_management !== 'shopify' || variant.variant_inventory_policy === 'continue') return true;
    return +variant.variant_quantity >= needed;
  }

  function isColorAvailable(colorOption, topVariants) {
    const top1 = colorOption.top_1_id;
    const top2 = colorOption.top_2_id;
    if (top1 && top2 && +top1 === +top2) return isTopAvailable(top1, topVariants, 2);
    return isTopAvailable(top1, topVariants) && isTopAvailable(top2, topVariants);
  }

  function checkColorStock() {
    const topVariants = getTopVariants();
    if (!topVariants) return;

    const colorInputs = document.querySelectorAll('input[name="color"]');
    colorInputs.forEach(color => {
      const available = isColorAvailable(
        { top_1_id: color.dataset.top_1_id, top_2_id: color.dataset.top_2_id },
        topVariants
      );
      if (available) {
        color.classList.remove('soldout');
        color.disabled = false;
      } else {
        color.classList.add('soldout');
        color.disabled = true;
      }
    });
  }

  // Disable a size pill when every one of its colors is unavailable
  function checkSizeStock() {
    const topVariants = getTopVariants();
    if (!topVariants) return;

    const sizePills = document.querySelectorAll('input[name="size-pill"]');
    sizePills.forEach(pill => {
      const sizeIndex = parseInt(pill.dataset.index, 10);
      const sizeData = data[sizeIndex];
      if (!sizeData || !sizeData.colors) return;

      const hasAvailableColor = sizeData.colors.some(color => isColorAvailable(color, topVariants));
      if (hasAvailableColor) {
        pill.classList.remove('soldout');
        pill.disabled = false;
      } else {
        pill.classList.add('soldout');
        pill.disabled = true;
      }
    });
  }

  function autoSelectFirstAvailableSize() {
    const checkedPill = document.querySelector('input[name="size-pill"]:checked');
    if (checkedPill && !checkedPill.disabled && !checkedPill.classList.contains('soldout')) {
      return;
    }

    const availablePills = document.querySelectorAll('input[name="size-pill"]:not(.soldout):not(:disabled)');
    if (availablePills.length > 0) {
      document.querySelectorAll('input[name="size-pill"]').forEach(p => p.checked = false);
      availablePills[0].checked = true;
      currentSizeIndex = parseInt(availablePills[0].dataset.index, 10);
    }
  }

  // ============================================
  // Auto-selection Logic
  // ============================================
  function autoSelectFirstAvailableColor() {
    const colorInputs = document.querySelectorAll('input[name="color"]:not(.soldout):not(:disabled)');

    if (colorInputs.length > 0) {
      // Uncheck all first
      document.querySelectorAll('input[name="color"]').forEach(input => {
        input.checked = false;
      });

      // Check first available
      colorInputs[0].checked = true;
      currentColorIndex = parseInt(colorInputs[0].dataset.index, 10);

      // Update display
      if (selectedColorSpan) {
        selectedColorSpan.textContent = colorInputs[0].dataset.title;
      }

      // Trigger grommet preselection
      preselectGrommets();
    }
  }

  function autoSelectFirstAvailableFrame() {
    const frameInputs = document.querySelectorAll('input[name="frame_color"]:not(.soldout):not(:disabled)');

    if (frameInputs.length > 0 && !Array.from(frameInputs).some(f => f.checked)) {
      frameInputs[0].checked = true;
      if (selectedFrameSpan) {
        selectedFrameSpan.textContent = frameInputs[0].value;
      }
    }
  }

  // ============================================
  // Event Handlers
  // ============================================
  function onSizeChange(e) {
    const isFrameOnly = e.target.dataset.frameOnly === 'true';
    const selectedIndex = parseInt(e.target.dataset.index, 10);

    // Handle frame-only mode
    if (isFrameOnly) {
      withoutTopMode = true;
      if (builderSection) {
        builderSection.classList.add('without-top-mode');
      }
      // Sync checkbox if it exists
      if (withoutTopCheckbox) {
        withoutTopCheckbox.checked = true;
      }
      // Clear color options
      if (colorOptionsContainer) {
        colorOptionsContainer.innerHTML = '';
      }
    } else {
      withoutTopMode = false;
      currentSizeIndex = selectedIndex;
      if (builderSection) {
        builderSection.classList.remove('without-top-mode');
      }
      // Sync checkbox if it exists
      if (withoutTopCheckbox) {
        withoutTopCheckbox.checked = false;
      }
      // Re-render colors for new size
      renderColorOptions(selectedIndex);
    }

    // Update builder state
    triggerBuilderUpdate();
  }

  function onColorChange(e) {
    currentColorIndex = parseInt(e.target.dataset.index, 10);

    // Update display
    if (selectedColorSpan) {
      selectedColorSpan.textContent = e.target.dataset.title;
    }

    // Preselect grommets
    preselectGrommets();

    // Update builder state
    triggerBuilderUpdate();
  }

  function onWithoutTopChange(e) {
    withoutTopMode = e.target.checked;

    if (builderSection) {
      if (withoutTopMode) {
        builderSection.classList.add('without-top-mode');
        // Select "Frame only" pill
        // const frameOnlyPill = document.getElementById('size-pill-frame-only');
        // if (frameOnlyPill) {
        //   frameOnlyPill.checked = true;
        // }
        // Clear color options
        if (colorOptionsContainer) {
          colorOptionsContainer.innerHTML = '';
        }
      } else {
        builderSection.classList.remove('without-top-mode');
        // Select first size pill
        const firstSizePill = document.querySelector('input[name="size-pill"]:not([data-frame-only])');
        if (firstSizePill) {
          firstSizePill.checked = true;
          currentSizeIndex = parseInt(firstSizePill.dataset.index, 10);
          renderColorOptions(currentSizeIndex);
        }
      }
    }

    // Update builder state
    triggerBuilderUpdate();
  }

  // ============================================
  // Grommet Handling
  // ============================================
  function preselectGrommets() {
    const colorInputs = document.querySelectorAll('input[name="color"]');
    const selected = Array.from(colorInputs).find(elem => elem.checked);

    if (!selected) return;

    const leftTopGrommet = document.getElementById('leftTopGrommet');
    const rightTopGrommet = document.getElementById('rightTopGrommet');
    const leftTopGrommetBtn = leftTopGrommet?.querySelector('button');
    const rightTopGrommetBtn = rightTopGrommet?.querySelector('button');
    const leftGrommetsList = leftTopGrommet?.querySelectorAll('.grommet-item');
    const rightGrommetsList = rightTopGrommet?.querySelectorAll('.grommet-item');
    const leftGrommetQty = leftTopGrommet?.querySelectorAll('.acc-quantity');
    const rightGrommetQty = rightTopGrommet?.querySelectorAll('.acc-quantity');
    const leftSelectedValue = leftTopGrommet?.querySelector('.selected-value');
    const rightSelectedValue = rightTopGrommet?.querySelector('.selected-value');

    const leftGrommetSize = selected.dataset.top_1_grommetsize;
    const leftGrommetCount = parseFloat(selected.dataset.top_1_grommetqty);
    const rightGrommetSize = selected.dataset.top_2_grommetsize;
    const rightGrommetCount = parseFloat(selected.dataset.top_2_grommetqty);

    // Left grommet
    if (leftTopGrommet && leftGrommetCount !== 0) {
      leftTopGrommetBtn.disabled = false;
      leftTopGrommet.classList.remove('hide');
      leftGrommetQty?.forEach(el => el.innerHTML = `x ${leftGrommetCount}`);

      leftGrommetsList?.forEach(elem => {
        if (!elem.classList.contains(leftGrommetSize)) {
          elem.classList.add('hide');
        } else {
          elem.classList.remove('hide');
        }
      });

      // Auto-select first available left grommet
      const availableLeft = Array.from(leftGrommetsList || []).filter(elem => !elem.classList.contains('hide'));
      if (availableLeft.length > 0) {
        const leftInput = availableLeft[0].querySelector('input');
        leftInput.checked = true;
        const leftPrice = leftInput.dataset.price / 100;
        if (leftSelectedValue) {
          leftSelectedValue.textContent = `${leftPrice} USD x ${leftGrommetCount} ${leftInput.dataset.sku}`;
        }
      }
    } else if (leftTopGrommet) {
      leftTopGrommetBtn.disabled = true;
      leftTopGrommet.classList.add('hide');
      leftGrommetQty?.forEach(el => el.innerHTML = '');
      if (leftSelectedValue) {
        leftSelectedValue.textContent = 'Select Table Top';
      }
    }

    // Right grommet
    if (rightTopGrommet && rightGrommetCount !== 0) {
      rightTopGrommetBtn.disabled = false;
      rightTopGrommet.classList.remove('hide');
      rightGrommetQty?.forEach(el => el.innerHTML = `x ${rightGrommetCount}`);

      rightGrommetsList?.forEach(elem => {
        if (!elem.classList.contains(rightGrommetSize)) {
          elem.classList.add('hide');
        } else {
          elem.classList.remove('hide');
        }
      });

      // Auto-select first available right grommet
      const availableRight = Array.from(rightGrommetsList || []).filter(elem => !elem.classList.contains('hide'));
      if (availableRight.length > 0) {
        const rightInput = availableRight[0].querySelector('input');
        rightInput.checked = true;
        const rightPrice = rightInput.dataset.price / 100;
        if (rightSelectedValue) {
          rightSelectedValue.textContent = `${rightPrice} USD x ${rightGrommetCount} ${rightInput.dataset.sku}`;
        }
      }
    } else if (rightTopGrommet) {
      rightTopGrommetBtn.disabled = true;
      rightTopGrommet.classList.add('hide');
      rightGrommetQty?.forEach(el => el.innerHTML = '');
      if (rightSelectedValue) {
        rightSelectedValue.textContent = 'Select Table Top';
      }
    }
  }

  // ============================================
  // Grommet Select UI Handlers
  // ============================================
  function initGrommetSelectUI() {
    const leftGrommetSelect = document.getElementById('leftTopGrommet');
    const rightGrommetSelect = document.getElementById('rightTopGrommet');

    if (leftGrommetSelect) {
      const btn = leftGrommetSelect.querySelector('.select-button');
      const options = leftGrommetSelect.querySelectorAll('.select-dropdown li');
      const selectedValue = leftGrommetSelect.querySelector('.selected-value');

      btn?.addEventListener('click', () => {
        leftGrommetSelect.classList.toggle('active');
        btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });

      options.forEach(option => {
        option.addEventListener('click', function(e) {
          if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
            selectedValue.textContent = this.children[1]?.textContent || '';
            leftGrommetSelect.classList.remove('active');
            triggerBuilderUpdate();
          }
        });
      });
    }

    if (rightGrommetSelect) {
      const btn = rightGrommetSelect.querySelector('.select-button');
      const options = rightGrommetSelect.querySelectorAll('.select-dropdown li');
      const selectedValue = rightGrommetSelect.querySelector('.selected-value');

      btn?.addEventListener('click', () => {
        rightGrommetSelect.classList.toggle('active');
        btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });

      options.forEach(option => {
        option.addEventListener('click', function(e) {
          if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
            selectedValue.textContent = this.children[1]?.textContent || '';
            rightGrommetSelect.classList.remove('active');
            triggerBuilderUpdate();
          }
        });
      });
    }
  }

  // ============================================
  // Builder Update Trigger
  // ============================================
  function triggerBuilderUpdate() {
    // Dispatch change event on the builder element
    const builder = document.querySelector('corner-builder-v2');
    if (builder) {
      builder.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ============================================
  // URL Parameter Reading for Preselection
  // ============================================
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      size: params.get('size'),
      color: params.get('color'),
      frame: params.get('frame'),
      leftGrommet: params.get('left_grommet'),
      rightGrommet: params.get('right_grommet'),
      withoutTop: params.get('without_top') === 'true',
      isModify: params.get('modify') === '1'
    };
  }

  function preselectSize(sizeId) {
    if (!sizeId) return false;

    const sizePill = document.querySelector(`input[name="size-pill"][value="${sizeId}"]`);
    if (sizePill && !sizePill.disabled && !sizePill.classList.contains('soldout')) {
      sizePill.checked = true;

      // Handle frame-only preselection
      if (sizeId === 'frame-only') {
        withoutTopMode = true;
        if (builderSection) {
          builderSection.classList.add('without-top-mode');
        }
        if (withoutTopCheckbox) {
          withoutTopCheckbox.checked = true;
        }
      } else {
        currentSizeIndex = parseInt(sizePill.dataset.index, 10);
      }
      return true;
    }
    return false;
  }

  function preselectColor(colorId) {
    if (!colorId) return false;

    const colorInput = document.querySelector(`input[name="color"][value="${colorId}"]`);
    if (colorInput && !colorInput.disabled && !colorInput.classList.contains('soldout')) {
      colorInput.checked = true;
      currentColorIndex = parseInt(colorInput.dataset.index, 10);
      if (selectedColorSpan) {
        selectedColorSpan.textContent = colorInput.dataset.title;
      }
      return true;
    }
    return false;
  }

  function preselectFrame(frameId) {
    if (!frameId) return false;

    const frameInput = document.getElementById(frameId);
    if (frameInput && !frameInput.disabled && !frameInput.classList.contains('soldout')) {
      frameInput.checked = true;
      if (selectedFrameSpan) {
        selectedFrameSpan.textContent = frameInput.value;
      }
      return true;
    }
    return false;
  }

  function preselectGrommetsFromUrl(leftGrommetId, rightGrommetId) {
    // Preselect left grommet from URL params
    if (leftGrommetId) {
      const leftContainer = document.getElementById('leftTopGrommet');
      if (leftContainer) {
        const leftInput = leftContainer.querySelector(`.grommet-input[value="${leftGrommetId}"]`);
        if (leftInput) {
          leftInput.checked = true;
          // Update display text with proper format
          const selectedValue = leftContainer.querySelector('.selected-value');
          const grommetCount = document.querySelector('input[name="color"]:checked')?.dataset.top_1_grommetqty || 1;
          const price = leftInput.dataset.price / 100;
          const sku = leftInput.dataset.sku;
          if (selectedValue) {
            selectedValue.textContent = `${price} USD x ${grommetCount} ${sku}`;
          }
        }
      }
    }

    // Preselect right grommet from URL params
    if (rightGrommetId) {
      const rightContainer = document.getElementById('rightTopGrommet');
      if (rightContainer) {
        const rightInput = rightContainer.querySelector(`.grommet-input[value="${rightGrommetId}"]`);
        if (rightInput) {
          rightInput.checked = true;
          // Update display text with proper format
          const selectedValue = rightContainer.querySelector('.selected-value');
          const grommetCount = document.querySelector('input[name="color"]:checked')?.dataset.top_2_grommetqty || 1;
          const price = rightInput.dataset.price / 100;
          const sku = rightInput.dataset.sku;
          if (selectedValue) {
            selectedValue.textContent = `${price} USD x ${grommetCount} ${sku}`;
          }
        }
      }
    }

    // Trigger builder update to refresh cornerSelectedGrommetV2
    triggerBuilderUpdate();
  }

  // ============================================
  // Initialization
  // ============================================
  function init() {
    const urlParams = getUrlParams();

    // Render size pills
    renderSizePills();

    // Disable sizes that have no available color at all
    checkSizeStock();

    // Preselect size from URL if available (guarded against unavailable sizes)
    if (urlParams.size) {
      preselectSize(urlParams.size);
    }

    // If the current size ended up unavailable, fall back to the first available one
    autoSelectFirstAvailableSize();

    // Render color options for selected size (skip if frame-only mode)
    if (!withoutTopMode) {
      renderColorOptions(currentSizeIndex);
    }

    // Preselect color from URL if available
    if (urlParams.color) {
      preselectColor(urlParams.color);
      // Re-run grommet preselection for the new color
      preselectGrommets();
    }

    // Preselect frame from URL, falling back to first available if missing/unavailable
    if (!urlParams.frame || !preselectFrame(urlParams.frame)) {
      autoSelectFirstAvailableFrame();
    }

    // Initialize grommet select UI
    initGrommetSelectUI();

    // Setup without-top checkbox
    if (withoutTopCheckbox) {
      withoutTopCheckbox.addEventListener('change', onWithoutTopChange);

      // Preselect without-top mode from URL
      if (urlParams.withoutTop) {
        withoutTopCheckbox.checked = true;
        onWithoutTopChange({ target: withoutTopCheckbox });
      }
    }

    // Initial builder state - this will auto-select grommets via preselectGrommets()
    setTimeout(() => {
      triggerBuilderUpdate();

      // After initial update, preselect grommets from URL (overriding auto-selection)
      if (urlParams.leftGrommet || urlParams.rightGrommet) {
        setTimeout(() => {
          preselectGrommetsFromUrl(urlParams.leftGrommet, urlParams.rightGrommet);
        }, 50);
      }
    }, 100);

    // Clear URL params after preselection (clean URL)
    if (urlParams.isModify) {
      setTimeout(() => {
        const cleanUrl = window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
      }, 200);
    }
  }

  init();
});


// ============================================
// Corner Builder V2 Web Component
// ============================================

let cornerOptionsV2 = {};
let cornerFrameOptionsV2 = {};
let cornerSelectedGrommetV2 = {};
let cornerProductsV2 = [];

class CornerBuilderV2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onBuilderChange);
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.cartBtn = document.querySelector('#BuilderSubmitButton');
    this.withoutTopMode = false;

    this.media_gallery = document.querySelector('.product__media-wrapper media-gallery');
    if (this.media_gallery) {
      this.deskTableSlide = this.media_gallery.querySelector('.desk-image-container');
      this.deskTableThumbnail = this.media_gallery.querySelector('.thumbnail-desk-image-container');
      if (this.deskTableThumbnail) {
        this.firstDefaultGalleryThumbnail = this.deskTableThumbnail.nextElementSibling;
        this.deskTableThumbnailButton = this.deskTableThumbnail.querySelector('button');
        this.firstDefaultGalleryThumbnailButton = this.firstDefaultGalleryThumbnail?.querySelector('button');
      }

      // Find frame-only image in product gallery (image with alt text containing "frame-only")
      this.frameOnlySlide = null;
      this.frameOnlyThumbnail = null;
      const gallerySlides = this.media_gallery.querySelectorAll('.product__media-item[data-media-id]');
      gallerySlides.forEach(slide => {
        const img = slide.querySelector('img');
        if (img && img.alt && img.alt.toLowerCase().includes('frame-only')) {
          this.frameOnlySlide = slide;
        }
      });
      if (this.frameOnlySlide) {
        const mediaId = this.frameOnlySlide.dataset.mediaId;
        const thumbnails = this.media_gallery.querySelector('.thumbnail-slider');
        if (thumbnails) {
          this.frameOnlyThumbnail = thumbnails.querySelector(`[data-target="${mediaId}"]`);
        }
      }
    }

    this.initCartButton();
  }

  initCartButton() {
    if (!this.cartBtn) return;

    this.cartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof e.stopPropagation === 'function') e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      if (this.cartBtn.classList.contains('loading') || this.cartBtn.getAttribute('aria-disabled') === 'true') {
        return;
      }

      // Get without-top mode
      const withoutTopCheckbox = document.getElementById('without-top-checkbox');
      this.withoutTopMode = withoutTopCheckbox?.checked || false;

      // Validation
      const colorOptions = document.querySelectorAll('input[name="color"]');
      const sizeOptions = document.querySelectorAll('input[name="size-pill"]');
      const frameOptions = document.querySelectorAll('input[name="frame_color"]');
      const leftGrommetsList = document.querySelectorAll('#leftTopGrommet .grommet-input');
      const rightGrommetsList = document.querySelectorAll('#rightTopGrommet .grommet-input');

      // Selection error helper
      const selectionCheck = (inputs, errorSelector, message) => {
        const errorWrapper = document.querySelector(errorSelector);
        let isSelected = false;

        if (inputs.length) {
          inputs.forEach(elem => {
            if (elem.checked) isSelected = true;
          });
        }

        if (errorWrapper) {
          if (isSelected) {
            return true;
          } else {
            errorWrapper.innerHTML = `<span class="builder-errors">${message}</span>`;
            setTimeout(() => errorWrapper.innerHTML = '', 2000);
            return false;
          }
        }
        return isSelected;
      };

      // Validate based on mode
      let isValid = true;

      isValid = selectionCheck(frameOptions, '#selectedFrame', 'Select Frame Color') && isValid;

      if (!this.withoutTopMode) {
        isValid = selectionCheck(colorOptions, '#selectedColor', 'Select Color') && isValid;
        // Size is always selected (first pill checked by default)

        if (cornerOptionsV2.top_1_grommetQty != 0) {
          isValid = selectionCheck(leftGrommetsList, '#selectedGrommet_1', 'Select Grommet') && isValid;
        }
        if (cornerOptionsV2.top_2_grommetQty != 0) {
          isValid = selectionCheck(rightGrommetsList, '#selectedGrommet_2', 'Select Grommet') && isValid;
        }
      }

      if (!isValid) return;

      // Check if ready to add
      const canAdd = this.withoutTopMode
        ? cornerFrameOptionsV2.frameId
        : (cornerOptionsV2.selectedSize && cornerFrameOptionsV2.frameId &&
           ((cornerOptionsV2.top_1_grommetQty != 0 && cornerSelectedGrommetV2.leftGrommetId) || cornerOptionsV2.top_1_grommetQty == 0) &&
           ((cornerOptionsV2.top_2_grommetQty != 0 && cornerSelectedGrommetV2.rightGrommetId) || cornerOptionsV2.top_2_grommetQty == 0));

      if (canAdd) {
        this.addToCart();
      }
    });
  }

  addToCart() {
    this.cartBtn.setAttribute('aria-disabled', true);
    this.cartBtn.classList.add('loading');
    const btn_overlay = this.cartBtn.querySelector('.loading-overlay__spinner');
    if (btn_overlay) btn_overlay.classList.remove('hidden');

    const request = JSON.parse(JSON.stringify(cornerProductsV2));
    const uniqueDeskId = Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
    request.forEach(el => {
      if (el.properties._desk_id) {
        el.properties._desk_id = uniqueDeskId;
      }
      return el;
    });

    // Items linked by _desk_id property (Shopify Script Editor blocks nested lines)
    const cartData = request.map(r => ({
      id: r.id,
      quantity: r.quantity,
      properties: r.properties
    }));

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const formData = { items: cartData };
    if (this.cart) {
      formData.sections = this.cart.getSectionsToRender().map(section => section.id);
      formData.sections_url = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = JSON.stringify(formData);

    fetch(`${routes.cart_add_url}`, config)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.cartBtn.setAttribute('aria-disabled', true);
          this.cartBtn.querySelector('span')?.classList.add('hidden');
          this.error = true;
          if (btn_overlay) btn_overlay.classList.add('hidden');
          this.handleErrorMessage(response.description);
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const builder_upsell_product_modalEl = document.querySelector('submit-upsell-modal');
        if (builder_upsell_product_modalEl) {
          builder_upsell_product_modalEl.openFormModal();
        }

        const upsell__modal = this.closest('.upsell__modal');
        if (upsell__modal) {
          upsell__modal.classList.remove('is-open');
        }

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.cartBtn.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
        if (!this.error) this.cartBtn.removeAttribute('aria-disabled');
        if (btn_overlay) btn_overlay.classList.add('hidden');
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;

    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  onBuilderChange() {
    const withoutTopCheckbox = document.getElementById('without-top-checkbox');
    this.withoutTopMode = withoutTopCheckbox?.checked || false;

    this.selectTableTop();
    this.onFrameChange();
    this.onGrommetChange();
    this.onPriceUpdate();

    if (!this.withoutTopMode && cornerOptionsV2.topQuantity && cornerFrameOptionsV2.frameId) {
      this.deskRender();
    } else if (this.withoutTopMode) {
      this.showFrameOnlyImage();
    } else {
      this.deskHide();
    }

    this.onBundleCreate();
  }

  selectTableTop() {
    cornerOptionsV2 = {};

    if (this.withoutTopMode) return;

    const sizeInputs = document.querySelectorAll('input[name="size-pill"]');
    const colorInputs = document.querySelectorAll('input[name="color"]');

    let selectedSize = null;
    let selectedColor = null;
    let topQuantity = null;
    let top_1_sku = null, top_1_id = null, top_1_grommetQty = null, top_1_grommetSize = null;
    let top_2_sku = null, top_2_id = null, top_2_grommetQty = null, top_2_grommetSize = null;
    let top_1_price = null, top_1_compare_price = null;
    let top_2_price = null, top_2_compare_price = null;

    sizeInputs.forEach(size => {
      if (size.checked) {
        selectedSize = size.value;
      }
    });

    colorInputs.forEach(color => {
      if (color.checked) {
        selectedColor = color.value;
        topQuantity = parseFloat(color.dataset.topsqty);
        top_1_sku = color.dataset.top_1_sku;
        top_1_id = parseFloat(color.dataset.top_1_id);
        top_1_grommetQty = parseFloat(color.dataset.top_1_grommetqty);
        top_1_grommetSize = color.dataset.top_1_grommetsize;
        top_2_sku = color.dataset.top_2_sku;
        top_2_id = parseFloat(color.dataset.top_2_id);
        top_2_grommetQty = parseFloat(color.dataset.top_2_grommetqty);
        top_2_grommetSize = color.dataset.top_2_grommetsize;
      }
    });

    if (selectedColor) {
      const topJsonEl = document.querySelector('#hidden-variant-metafields-container');
      if (topJsonEl) {
        try {
          const topVariants = JSON.parse(topJsonEl.innerHTML);
          topVariants.forEach(el => {
            if (top_1_id == +el.variant_id) {
              top_1_price = Math.round(el.variant_price);
              top_1_compare_price = el.variant_compare_at_price ? Math.round(el.variant_compare_at_price) : null;
            }
            if (top_2_id == +el.variant_id) {
              top_2_price = Math.round(el.variant_price);
              top_2_compare_price = el.variant_compare_at_price ? Math.round(el.variant_compare_at_price) : null;
            }
          });
        } catch (e) {
          console.error('Error parsing variant data:', e);
        }
      }

      cornerOptionsV2 = {
        selectedColor,
        selectedSize,
        topQuantity,
        top_1_sku, top_1_id, top_1_grommetQty, top_1_grommetSize, top_1_price, top_1_compare_price,
        top_2_sku, top_2_id, top_2_grommetQty, top_2_grommetSize, top_2_price, top_2_compare_price
      };
    }
  }

  onFrameChange() {
    cornerFrameOptionsV2 = {};
    const frameInputs = document.querySelectorAll('input[name="frame_color"]');
    const selectedFrameSpan = document.querySelector('#selectedFrame');

    let frameId = null, framePrice = null, frameComparePrice = null, frameSku = null, frameValue = '';

    frameInputs.forEach(el => {
      if (el.checked) {
        frameId = parseFloat(el.id);
        framePrice = Math.round(el.dataset.price);
        frameComparePrice = el.dataset.comparePrice ? Math.round(el.dataset.comparePrice) : null;
        frameSku = el.dataset.variantsku;
        frameValue = el.value;
      }
    });

    if (frameId && framePrice) {
      cornerFrameOptionsV2 = { frameId, framePrice, frameComparePrice, frameSku, frameValue };
      if (selectedFrameSpan) selectedFrameSpan.innerHTML = frameValue;
    } else {
      cornerFrameOptionsV2 = {};
      if (selectedFrameSpan) selectedFrameSpan.innerHTML = '';
    }
  }

  onGrommetChange() {
    cornerSelectedGrommetV2 = {};

    if (this.withoutTopMode) return;

    const leftGrommetsList = document.querySelectorAll('#leftTopGrommet .grommet-input');
    const rightGrommetsList = document.querySelectorAll('#rightTopGrommet .grommet-input');

    let leftGrommetId = null, leftGrommetSku = null, leftGrommetPrice = null, leftGrommetComparePrice = null;
    let rightGrommetId = null, rightGrommetSku = null, rightGrommetPrice = null, rightGrommetComparePrice = null;

    leftGrommetsList.forEach(elem => {
      if (elem.checked) {
        leftGrommetId = parseFloat(elem.value);
        leftGrommetSku = elem.dataset.sku;
        leftGrommetPrice = Math.round(elem.dataset.price);
        leftGrommetComparePrice = elem.dataset.comparePrice ? Math.round(elem.dataset.comparePrice) : null;
      }
    });

    rightGrommetsList.forEach(elem => {
      if (elem.checked) {
        rightGrommetId = parseFloat(elem.value);
        rightGrommetSku = elem.dataset.sku;
        rightGrommetPrice = Math.round(elem.dataset.price);
        rightGrommetComparePrice = elem.dataset.comparePrice ? Math.round(elem.dataset.comparePrice) : null;
      }
    });

    cornerSelectedGrommetV2 = {
      leftGrommetId, leftGrommetSku, leftGrommetPrice, leftGrommetComparePrice,
      rightGrommetId, rightGrommetSku, rightGrommetPrice, rightGrommetComparePrice
    };
  }

  onPriceUpdate() {
    const priceWrapper = document.querySelector('.builder-price');
    const comparePriceWrapper = document.querySelector('.builder-price-compare');
    const priceFrom = document.querySelector('.starting_txt');
    const quantityInput = document.querySelector('.builder-desk-qty');
    const btnPriceEl = document.querySelector('.product-form__cart-submit-price');
    const stickyVariantPriceEl = document.querySelector('.sticky-variant-price');

    let qtyValue = Number(quantityInput?.value || 1);
    let priceArr = [];
    let comparePriceArr = [];
    let hasAnyComparePrice = false;

    // Frame price
    if (!isNaN(cornerFrameOptionsV2.framePrice)) {
      priceArr.push(cornerFrameOptionsV2.framePrice);
      if (cornerFrameOptionsV2.frameComparePrice && cornerFrameOptionsV2.frameComparePrice > cornerFrameOptionsV2.framePrice) {
        comparePriceArr.push(cornerFrameOptionsV2.frameComparePrice);
        hasAnyComparePrice = true;
      } else {
        comparePriceArr.push(cornerFrameOptionsV2.framePrice);
      }
    }

    if (!this.withoutTopMode) {
      // Tops price
      const topsPrice = (cornerOptionsV2.top_1_price || 0) + (cornerOptionsV2.top_2_price || 0);
      if (!isNaN(topsPrice) && topsPrice > 0) {
        priceArr.push(topsPrice);

        let topsComparePrice = 0;
        if (cornerOptionsV2.top_1_price) {
          if (cornerOptionsV2.top_1_compare_price && cornerOptionsV2.top_1_compare_price > cornerOptionsV2.top_1_price) {
            topsComparePrice += cornerOptionsV2.top_1_compare_price;
            hasAnyComparePrice = true;
          } else {
            topsComparePrice += cornerOptionsV2.top_1_price;
          }
        }
        if (cornerOptionsV2.top_2_price) {
          if (cornerOptionsV2.top_2_compare_price && cornerOptionsV2.top_2_compare_price > cornerOptionsV2.top_2_price) {
            topsComparePrice += cornerOptionsV2.top_2_compare_price;
            hasAnyComparePrice = true;
          } else {
            topsComparePrice += cornerOptionsV2.top_2_price;
          }
        }
        comparePriceArr.push(topsComparePrice);
      }

      // Grommets price
      const grommetsPrice =
        (cornerSelectedGrommetV2.leftGrommetPrice || 0) * (cornerOptionsV2.top_1_grommetQty || 0) +
        (cornerSelectedGrommetV2.rightGrommetPrice || 0) * (cornerOptionsV2.top_2_grommetQty || 0);

      if (!isNaN(grommetsPrice) && grommetsPrice > 0) {
        priceArr.push(grommetsPrice);

        let grommetsComparePrice = 0;
        const leftGrommetTotal = (cornerSelectedGrommetV2.leftGrommetPrice || 0) * (cornerOptionsV2.top_1_grommetQty || 0);
        if (cornerSelectedGrommetV2.leftGrommetComparePrice && cornerSelectedGrommetV2.leftGrommetComparePrice > cornerSelectedGrommetV2.leftGrommetPrice) {
          grommetsComparePrice += cornerSelectedGrommetV2.leftGrommetComparePrice * (cornerOptionsV2.top_1_grommetQty || 0);
          hasAnyComparePrice = true;
        } else {
          grommetsComparePrice += leftGrommetTotal;
        }

        const rightGrommetTotal = (cornerSelectedGrommetV2.rightGrommetPrice || 0) * (cornerOptionsV2.top_2_grommetQty || 0);
        if (cornerSelectedGrommetV2.rightGrommetComparePrice && cornerSelectedGrommetV2.rightGrommetComparePrice > cornerSelectedGrommetV2.rightGrommetPrice) {
          grommetsComparePrice += cornerSelectedGrommetV2.rightGrommetComparePrice * (cornerOptionsV2.top_2_grommetQty || 0);
          hasAnyComparePrice = true;
        } else {
          grommetsComparePrice += rightGrommetTotal;
        }
        comparePriceArr.push(grommetsComparePrice);
      }
    }

    if (!hasAnyComparePrice) {
      comparePriceArr = [];
    }

    let deskTotalSum = priceArr.reduce((sum, elem) => sum + elem, 0);
    let deskTotalCompareSum = comparePriceArr.reduce((sum, elem) => sum + elem, 0);

    const starting = Number(priceWrapper?.dataset.starting || 0);

    // In without-top mode, show frame price regardless of starting price
    // In normal mode, only show if price >= starting price

    // const finalDiscountPrice = Math.round(deskTotalSum * 0.72 * 100) / 100; // - 28% discount
    // Shopify rounds each cart line up to the cent after discounts:
    // FLT-05 frames get only 10%, everything else gets 20% + 10% (-28%)
    const discountedLine = (linePrice, rate) => Math.ceil(Number((linePrice * rate).toFixed(6)));
    const frameDiscountRate = (cornerFrameOptionsV2.frameSku || '').startsWith('FLT-05') ? 0.9 : 0.72;
    let finalDiscountPrice = discountedLine(Number(cornerFrameOptionsV2.framePrice) || 0, frameDiscountRate);
    if (!this.withoutTopMode) {
      finalDiscountPrice += discountedLine(cornerOptionsV2.top_1_price || 0, 0.72);
      finalDiscountPrice += discountedLine(cornerOptionsV2.top_2_price || 0, 0.72);
      finalDiscountPrice += discountedLine((cornerSelectedGrommetV2.leftGrommetPrice || 0) * (cornerOptionsV2.top_1_grommetQty || 0), 0.72);
      finalDiscountPrice += discountedLine((cornerSelectedGrommetV2.rightGrommetPrice || 0) * (cornerOptionsV2.top_2_grommetQty || 0), 0.72);
    }
    // const finalDiscountPrice = Math.ceil(deskTotalSum * 0.70 / 5) * 5; // 30% discount

    if ((this.withoutTopMode || deskTotalSum >= starting) && priceWrapper && deskTotalSum > 0) {
      priceWrapper.innerHTML = formatMoney(finalDiscountPrice * qtyValue, window.moneyFormat);

      if (comparePriceWrapper) {
        comparePriceWrapper.innerHTML = '<s>' + formatMoney(deskTotalCompareSum * qtyValue, window.moneyFormat) + '</s>';
        comparePriceWrapper.style.display = 'block';
        priceWrapper.classList.add('red-price');
      } else {
        comparePriceWrapper.style.display = 'none';
        priceWrapper.classList.remove('red-price');
      }

      if (stickyVariantPriceEl) {
        stickyVariantPriceEl.innerHTML = formatMoney(finalDiscountPrice * qtyValue, window.moneyFormat);
      }

      if (priceFrom) priceFrom.classList.add('hide');

      if (btnPriceEl) {
        btnPriceEl.innerHTML = formatMoney(finalDiscountPrice * qtyValue, window.moneyFormat);
        btnPriceEl.classList.remove('hide');
      }
    }
  }

  deskRender() {
    // Image rendering logic
    if (!this.media_gallery || !this.deskTableThumbnail) return;

    const medisdeskWrapperItems = document.querySelectorAll('.builder-media-wrapper');

    let deskColor = cornerOptionsV2.selectedColor || '';
    let frameSku = cornerFrameOptionsV2.frameSku || '';
    let frameValue = cornerFrameOptionsV2.frameValue || '';
    let fullSize = (cornerOptionsV2.selectedSize || '').replace('x', '');

    // Get top SKUs for size extraction and D80 check
    let top1Sku = cornerOptionsV2.top_1_sku || '';
    let top2Sku = cornerOptionsV2.top_2_sku || '';

    // Extract size from SKU (e.g., "DT-90-CW" → "90", "DT-3030-WW" → "3030")
    // Used as fallback for products where image size differs from config size
    let skuSize = null;
    const skuSizeMatch = top1Sku.match(/DT-(\d+)-/);
    if (skuSizeMatch) {
      skuSize = skuSizeMatch[1];
    }

    // Color mapping for tabletop colors
    const colorMap = {
      'WarmWhite': 'WW', 'BrightBeech': 'BB', 'GrayOak': 'GO', 'RusticHickory': 'RH',
      'LightWalnut': 'LW', 'DarkCherry': 'DC', 'RoastedWalnut': 'RW', 'EbonyOak': 'EO',
      'PureBlack': 'PB', 'CoolWhite': 'CW', 'WhiteBirch': 'WB', 'SunsetTeak': 'ST',
      'DarkOak': 'DO', 'MidnightMaple': 'MM'
    };

    // Frame SKU to frame color name mapping (for image matching)
    // Images use "White", "Black", or "Gray" in filename
    const frameColorMap = {
      'DF-02-W': 'White', 'DF-02-B': 'Black',
      'DF-01-W': 'White', 'DF-01-B': 'Black',
      'White': 'White', 'Black': 'Black', 'Gray': 'Gray'
    };

    let renderColor = colorMap[deskColor] || '';
    // Check frameColorMap first, then try to extract color from SKU (e.g., "FLT-05-White" -> "White")
    let renderFrameColor = frameColorMap[frameSku] || '';
    if (!renderFrameColor && frameSku) {
      // Try to extract color from SKU like "FLT-05-White", "FLT-05-Black", "FLT-05-Gray"
      const skuColorMatch = frameSku.match(/-(White|Black|Gray)$/i);
      if (skuColorMatch) {
        renderFrameColor = skuColorMatch[1];
      }
    }
    if (!renderFrameColor) {
      renderFrameColor = frameValue || '';
    }

    // Check if this size uses D80 variant (has -D80 in either top SKU)
    let hasD80 = top1Sku.includes('-D80') || top2Sku.includes('-D80');

    // Size mapping for cases where image size differs from config size
    const imageSizeMap = {
      '9048': '8548',  // 90x48 uses 8548 in image names
      '9060': '8355',  // 90x60 uses 8355 in image names
      '7860': '7555',  // 78x60 uses 7555 in image names
      '8855': '8355'   // 88x55 uses 8355 in image names
    };
    const mappedSize = imageSizeMap[fullSize] || null;

    if (!renderFrameColor || !fullSize || !renderColor) {
      this.deskHide();
      return;
    }

    // Hide all images first
    medisdeskWrapperItems.forEach(el => {
      el.style.display = 'none';
    });

    // Build matching criteria
    // Image format example: SD-FLT-05-White-DT-6060-WW-D80-DA-10-B
    // We need to match: frame color (White/Black), size (6060), tabletop color (WW), and D80 if applicable

    // Helper function to find matching image with given size
    const findImageWithSize = (sizeToMatch, requireD80Match = true) => {
      for (const el of medisdeskWrapperItems) {
        const sku = el.dataset.desksku || '';

        // Check frame color (White, Black, or Gray in image name)
        // Frame color should be in the beginning part like "SD-FLT-05-Black-DT-..." not at the end like "...-DA-10-Black"
        const frameColorRegex = new RegExp(`^SD-[A-Z]+-\\d+-${renderFrameColor}-`);
        const frameSkuHasColor = frameSku && (frameSku.includes('White') || frameSku.includes('Black') || frameSku.includes('Gray'));
        const hasFrameColor = frameColorRegex.test(sku) || (frameSkuHasColor && sku.includes(frameSku));

        // Check size (e.g., 6060, 7248, 90)
        const hasSize = sku.includes(sizeToMatch);

        // Check tabletop color (e.g., WW, BB, GO)
        // Use regex to match color code followed by dash or end, e.g., "-WW-" or "WW-D80"
        const colorRegex = new RegExp(`[-_]${renderColor}[-_]|[-_]${renderColor}$|DT-\\d+-${renderColor}|${renderColor}-`);
        const hasColor = colorRegex.test(sku);

        // Check D80 match if applicable
        const skuHasD80 = sku.includes('D80');
        const d80Match = hasD80 ? skuHasD80 : !skuHasD80; // Match D80 presence

        if (requireD80Match) {
          if (hasFrameColor && hasSize && hasColor && d80Match) {
            console.log('Desk render matched:', sku);
            el.style.display = 'block';
            return true;
          }
        } else {
          if (hasFrameColor && hasSize && hasColor) {
            console.log('Desk render matched (no D80 req):', sku);
            el.style.display = 'block';
            return true;
          }
        }
      }
      return false;
    };

    let foundImage = false;

    console.log('Looking for desk render:', { fullSize, skuSize, mappedSize, renderColor, renderFrameColor, hasD80, frameSku });

    // Try all D80 options first, then fallback to non-D80
    // Try 1: Match with fullSize (combined config size, e.g., "6048") with D80 check
    foundImage = findImageWithSize(fullSize, true);

    // Try 2: Match with mappedSize (e.g., "9048" -> "8548") with D80 check
    if (!foundImage && mappedSize) {
      foundImage = findImageWithSize(mappedSize, true);
    }

    // Try 3: Match with skuSize (extracted from SKU, e.g., "90") with D80 check
    if (!foundImage && skuSize && skuSize !== fullSize) {
      foundImage = findImageWithSize(skuSize, true);
    }

    // Try 4: Match with fullSize without D80 requirement
    if (!foundImage) {
      foundImage = findImageWithSize(fullSize, false);
    }

    // Try 5: Match with mappedSize without D80 requirement
    if (!foundImage && mappedSize) {
      foundImage = findImageWithSize(mappedSize, false);
    }

    // Try 6: Match with skuSize without D80 requirement
    if (!foundImage && skuSize && skuSize !== fullSize) {
      foundImage = findImageWithSize(skuSize, false);
    }

    this.deskTableThumbnailImages = this.deskTableThumbnail.querySelectorAll('.builder-thumb-desk-image');

    // Hide all thumbnails first
    this.deskTableThumbnailImages.forEach(el => {
      el.style.display = 'none';
    });

    // Helper function to find matching thumbnail with given size
    const findThumbnailWithSize = (sizeToMatch, requireD80Match = true) => {
      for (const el of this.deskTableThumbnailImages) {
        const sku = el.dataset.desksku || '';

        // Frame color should be in the beginning part like "SD-FLT-05-Black-DT-..." not at the end
        const frameColorRegex = new RegExp(`^SD-[A-Z]+-\\d+-${renderFrameColor}-`);
        const frameSkuHasColor = frameSku && (frameSku.includes('White') || frameSku.includes('Black') || frameSku.includes('Gray'));
        const hasFrameColor = frameColorRegex.test(sku) || (frameSkuHasColor && sku.includes(frameSku));
        const hasSize = sku.includes(sizeToMatch);
        const colorRegex = new RegExp(`[-_]${renderColor}[-_]|[-_]${renderColor}$|DT-\\d+-${renderColor}|${renderColor}-`);
        const hasColor = colorRegex.test(sku);
        const skuHasD80 = sku.includes('D80');
        const d80Match = hasD80 ? skuHasD80 : !skuHasD80;

        if (requireD80Match) {
          if (hasFrameColor && hasSize && hasColor && d80Match) {
            el.style.display = 'block';
            return true;
          }
        } else {
          if (hasFrameColor && hasSize && hasColor) {
            el.style.display = 'block';
            return true;
          }
        }
      }
      return false;
    };

    // Try thumbnail matching with same fallback logic as main images (D80 first, then non-D80)
    let foundThumb = findThumbnailWithSize(fullSize, true);
    if (!foundThumb && mappedSize) {
      foundThumb = findThumbnailWithSize(mappedSize, true);
    }
    if (!foundThumb && skuSize && skuSize !== fullSize) {
      foundThumb = findThumbnailWithSize(skuSize, true);
    }
    if (!foundThumb) {
      foundThumb = findThumbnailWithSize(fullSize, false);
    }
    if (!foundThumb && mappedSize) {
      foundThumb = findThumbnailWithSize(mappedSize, false);
    }
    if (!foundThumb && skuSize && skuSize !== fullSize) {
      foundThumb = findThumbnailWithSize(skuSize, false);
    }

    if (foundImage) {
      this.deskTableThumbnail.classList.remove('hide');
      if (this.deskTableSlide) this.deskTableSlide.classList.remove('hide');
      this.media_gallery.setActiveThumbnail?.(this.deskTableThumbnail);
      this.deskTableThumbnailButton?.dispatchEvent(new Event('click', { bubbles: true }));
    } else {
      this.deskHide();
    }
  }

  showFrameOnlyImage() {
    // Hide builder desk renders first
    const medisdeskWrapperItems = document.querySelectorAll('.builder-media-wrapper');
    medisdeskWrapperItems.forEach(el => {
      el.style.display = 'none';
    });
    if (this.deskTableThumbnail) {
      this.deskTableThumbnail.classList.add('hide');
    }
    if (this.deskTableSlide) {
      this.deskTableSlide.classList.add('hide');
    }

    // Navigate to the frame-only product image if it exists
    if (this.frameOnlySlide && this.media_gallery) {
      const mediaId = this.frameOnlySlide.dataset.mediaId;
      this.media_gallery.setActiveMedia?.(mediaId, false);
    } else if (this.media_gallery && this.firstDefaultGalleryThumbnail) {
      // Fallback to first default image if no frame-only image found
      this.media_gallery.setActiveThumbnail?.(this.firstDefaultGalleryThumbnail);
      this.firstDefaultGalleryThumbnailButton?.dispatchEvent(new Event('click', { bubbles: true }));
    }
  }

  deskHide() {
    const medisdeskWrapperItems = document.querySelectorAll('.builder-media-wrapper');
    medisdeskWrapperItems.forEach(el => {
      el.style.display = 'none';
    });

    if (this.deskTableThumbnail) {
      this.deskTableThumbnail.classList.add('hide');
    }
    if (this.deskTableSlide) {
      this.deskTableSlide.classList.add('hide');
    }
    if (this.media_gallery && this.firstDefaultGalleryThumbnail) {
      this.media_gallery.setActiveThumbnail?.(this.firstDefaultGalleryThumbnail);
      this.firstDefaultGalleryThumbnailButton?.dispatchEvent(new Event('click', { bubbles: true }));
    }
  }

  onBundleCreate() {
    cornerProductsV2 = [];

    const quantityInput = document.querySelector('.builder-desk-qty');
    const quantity = Number(quantityInput?.value || 1);
    const deskType = this.dataset.type;
    const deskId = Date.now().toString(36);
    const builderUrl = this.dataset.productUrl || '';

    // Get current selections for preselection on modify
    const selectedSizePill = document.querySelector('input[name="size-pill"]:checked');
    const selectedColorInput = document.querySelector('input[name="color"]:checked');
    const selectedFrameInput = document.querySelector('input[name="frame_color"]:checked');

    const configSize = selectedSizePill ? selectedSizePill.value : '';
    const configColor = selectedColorInput ? selectedColorInput.value : '';
    const configFrame = selectedFrameInput ? selectedFrameInput.id : '';
    const configLeftGrommet = cornerSelectedGrommetV2.leftGrommetId || '';
    const configRightGrommet = cornerSelectedGrommetV2.rightGrommetId || '';

    // Without top mode - only frame (no nested items needed)
    if (this.withoutTopMode) {
      if (cornerFrameOptionsV2.frameId) {
        cornerProductsV2.push({
          id: cornerFrameOptionsV2.frameId,
          quantity: quantity,
          properties: {
            _volume_disc: '',
            _builder: 'desk_builder',
            _desk_type: deskType,
            _desk_id: deskId,
            _builder_url: builderUrl,
            _componets: quantity,
            _type: 'Frame',
            _frame_only: 'true',
            _config_size: configSize,
            _config_frame: configFrame,
            _config_without_top: 'true'
          }
        });
      }
      return;
    }

    // Full desk mode - items linked by _desk_id property
    let components = 0;
    if (cornerOptionsV2.topQuantity == 1) {
      components = (cornerOptionsV2.top_1_grommetQty || 0) + 2;
    } else {
      components = (cornerOptionsV2.top_1_grommetQty || 0) + (cornerOptionsV2.top_2_grommetQty || 0) + 3;
    }

    const isReady = cornerOptionsV2.topQuantity && cornerFrameOptionsV2.frameId &&
      ((cornerOptionsV2.top_1_grommetQty != 0 && cornerSelectedGrommetV2.leftGrommetId) || cornerOptionsV2.top_1_grommetQty == 0) &&
      ((cornerOptionsV2.top_2_grommetQty != 0 && cornerSelectedGrommetV2.rightGrommetId) || cornerOptionsV2.top_2_grommetQty == 0);

    if (isReady) {
      // Add frame
      cornerProductsV2.push({
        id: cornerFrameOptionsV2.frameId,
        quantity: quantity,
        properties: {
          _volume_disc: '',
          _builder: 'desk_builder',
          _desk_type: deskType,
          _desk_id: deskId,
          _builder_url: builderUrl,
          _componets: components * quantity,
          _type: 'Frame',
          _config_size: configSize,
          _config_color: configColor,
          _config_frame: configFrame,
          _config_left_grommet: configLeftGrommet,
          _config_right_grommet: configRightGrommet
        }
      });

      // Add tabletops
      if (cornerOptionsV2.topQuantity >= 1 && cornerOptionsV2.top_1_id) {
        cornerProductsV2.push({
          id: cornerOptionsV2.top_1_id,
          quantity: quantity,
          properties: {
            _volume_disc: '',
            _builder: 'desk_builder',
            _desk_type: deskType,
            _desk_id: deskId,
            _builder_url: builderUrl,
            _componets: components * quantity,
            _type: 'Left Tabletop'
          }
        });
      }

      if (cornerOptionsV2.topQuantity >= 2 && cornerOptionsV2.top_2_id) {
        cornerProductsV2.push({
          id: cornerOptionsV2.top_2_id,
          quantity: quantity,
          properties: {
            _volume_disc: '',
            _builder: 'desk_builder',
            _desk_type: deskType,
            _desk_id: deskId,
            _builder_url: builderUrl,
            _componets: components * quantity,
            _type: 'Right Tabletop'
          }
        });
      }

      // Add grommets
      if (cornerOptionsV2.top_1_grommetQty != 0 && cornerSelectedGrommetV2.leftGrommetId) {
        cornerProductsV2.push({
          id: cornerSelectedGrommetV2.leftGrommetId,
          quantity: cornerOptionsV2.top_1_grommetQty * quantity,
          properties: {
            _volume_disc: '',
            _builder: 'desk_builder',
            _desk_type: deskType,
            _desk_id: deskId,
            _builder_url: builderUrl,
            _componets: components * quantity,
            _type: 'Grommet'
          }
        });
      }

      if (cornerOptionsV2.top_2_grommetQty != 0 && cornerSelectedGrommetV2.rightGrommetId) {
        cornerProductsV2.push({
          id: cornerSelectedGrommetV2.rightGrommetId,
          quantity: cornerOptionsV2.top_2_grommetQty * quantity,
          properties: {
            _volume_disc: '',
            _builder: 'desk_builder',
            _desk_type: deskType,
            _desk_id: deskId,
            _builder_url: builderUrl,
            _componets: components * quantity,
            _type: 'Grommet'
          }
        });
      }
    }
  }
}

customElements.define('corner-builder-v2', CornerBuilderV2);
